// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";

export function xHasChanges(state: ApplicationState) {
    const {
        accountSettings: {
            editingAccount,
            initialUseDefaultCustomer,
            useDefaultCustomer,
            initialShipToId,
            selectedShipToId,
        },
    } = state.pages;
    const account = getCurrentAccountState(state).value;
    if (!account || !editingAccount) {
        return false;
    }

    return (
        // account.email !== editingAccount.email ||
        account.setDefaultCustomer !== editingAccount.setDefaultCustomer ||
        // account.isSubscribed !== editingAccount.isSubscribed ||
        account.defaultFulfillmentMethod !== editingAccount.defaultFulfillmentMethod ||
        account.defaultWarehouseId !== editingAccount.defaultWarehouseId ||
        useDefaultCustomer !== initialUseDefaultCustomer ||
        initialShipToId !== selectedShipToId
    );
}
